import React from 'react';
import { IProps as IFiftyFiftyImageBlockProps } from './FiftyFiftyImageBlock.interface';
import { IProps as IButtonProps } from '@/elements/Button/Button.interface';
import { FiftyFiftyImageBlock } from './FiftyFiftyImageBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import { mapAnchorProps, mapImageProps } from '@/utils/TranslationComponent/translation.utilities';

export interface IFiftyFiftyImageBlockInputProps {
    displayOrder?: 'ltr' | 'rtl';
    heading?: string;
    content?: string;
    buttons?: any[]; // Replace 'any' with a more specific button prop type if available
    image?: {
        alternateText: string;
        defaultSrc: string;
        sizesAttribute?: string[];
        srcSet: string[];
        srcSetWebp?: string[];
        isBackground?: boolean;
        textContent?: string;
        isLazy?: boolean;
    };
    imageDescription?: string | null;
    background?: ThemeColors;
    parentClass?: string;
    anchorId?: string;
    [key: string]: any;
}

const mapInputToProps = (
    input: IFiftyFiftyImageBlockInputProps,
): IFiftyFiftyImageBlockProps => {
    const returnProps = {
        ...input,
        heading: input.heading,
        text: input.content,
        buttons: input.buttons?.map((button) => mapAnchorProps(button)),
        image: mapImageProps(input.image),
        caption: input.imageDescription || undefined,
        mediaPosition: input.mediaPosition || 'right',
        backgroundColor: input.background || 'white',
    } as IFiftyFiftyImageBlockProps;
    return returnProps;
};

const FiftyFiftyImageBlockTranslation: React.FC<
    IFiftyFiftyImageBlockInputProps
> = (inputProps) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={FiftyFiftyImageBlock}
        mapProps={mapInputToProps}
    />
);

export default FiftyFiftyImageBlockTranslation;
